// extracted by mini-css-extract-plugin
module.exports = {"confirm__text":"ConfirmSuccess_confirm__text__DVT6r","confirm__buttons":"ConfirmSuccess_confirm__buttons__1pHCR"};